<div class="frame-parent" *ngIf="!showIframeFlag">
  <div class="frame-group">
    <div class="title-wrapper">
      <div class="title">
        <div class="title1">{{ 'name-change' | translate }}</div>
      </div>
    </div>
    <div class="tramita-el-cambio">
      {{ 'name-change-description' | translate }}
    </div>
  </div>
  <div class="title-parent">
    <div class="title">
      <div class="title1">{{ 'how-does-it-work' | translate }}</div>
    </div>
    <div class="tag-parent">
      <div class="tag">
        <img
          class="iconsoutlinesearch"
          alt=""
          src="../assets/icons/search-icon-black.svg"
        />
        <div class="text">
          {{ 'name-change-how-does-it-works-text-1' | translate }}
        </div>
      </div>
      <div class="tag">
        <div class="iconsoutlinesearch">
          <img
            class="group-icon"
            alt=""
            src="../assets/icons/paper-plane-icon.svg"
          />
        </div>
        <div class="text">
          {{ 'name-change-how-does-it-works-text-2' | translate }}
        </div>
      </div>
      <div class="tag">
        <div class="iconsoutlinesearch">
          <img
            class="vector-icon"
            alt=""
            src="../assets/icons/document-ok-icon.svg"
          />
        </div>
        <div class="text">
          {{ 'name-change-how-does-it-works-text-3' | translate }}
        </div>
      </div>
      <div class="tag">
        <div class="iconsoutlinesearch">
          <img
            class="vector-icon"
            alt=""
            src="../assets/icons/document-text-icon.svg"
          />
        </div>
        <div class="text">
          {{ 'name-change-how-does-it-works-text-4' | translate }}
        </div>
      </div>
    </div>
  </div>
  <button class="continue-button2" (click)="showIframe()">
    <div class="text-button">{{ 'solitude' | translate }}</div>
  </button>
</div>
<div class="frame-container" *ngIf="showIframeFlag">
    <iframe
    src="assets/widgets/change-name-widget.html"
    width="100%"
    height="665px"
    frameborder="0"
  ></iframe>
</div>
